import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="user-form"
export default class extends Controller {
  static targets = ["distributorRow", "customerRow", "roleSelect"]

  connect() {
    this.toggleByRole()
  }

  toggleByRole() {
    const role = this.roleSelectTarget.value
    this.distributorRowTarget.hidden = role !== "distributor"
    this.customerRowTarget.hidden = role !== "customer"
  }

  toggleDistributor() {
    this.toggleByRole()
  }
}
